<template>
  <div id="app">
    <vue-topprogress ref="topProgress"></vue-topprogress>
    <router-view class="view"></router-view>
    <swarm-footer />
  </div>
</template>

<script>
import SwarmFooter from './components/common/Footer.vue'

export default {
  async created() {
    await this.$store.dispatch('installServiceWorker')
  },
  components: {
    SwarmFooter
  }
}
</script>

<style lang="scss">
/**
  https://www.stevesouders.com/blog/2010/06/01/frontend-spof/
  https://www.webucator.com/blog/2016/11/inline-web-font-avoid-fout/
  Inline the font-face
   */
@import './styles/fonts-google/fonts.css';
@import './styles/element-variables.scss';
@import './styles/app.scss';
@import './styles/element-ui-patch.scss';
@import './styles/ckeditor.scss';
@import './styles/pmath.scss';
</style>
